import * as React from 'react'
import { styled } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'

type CoachingProps = {
  className?: string
  children: React.ReactNode
}

function TipComponent({ children, className }: CoachingProps) {
  return (
    <div className={className}>
      <plume.glyphs.stroke.Bulb size={10} />
      <plume.styles.copy.S.regular>{children}</plume.styles.copy.S.regular>
    </div>
  )
}

export const Tip = styled(TipComponent)`
  background-color: ${plume.COLORS.PRIMARY_GREY_000};
  display: flex;
  margin: 10px 0 20px;
  display: flex;
  margin: 10px 0px;
  z-index: 2;

  ${plume.glyphs.stroke.Bulb} {
    background-color: ${plume.COLORS.SECONDARY_GREEN_500};
    color: ${plume.COLORS.PRIMARY_GREY_000};
    border-radius: 50%;
    width: 10px;
    height: 14px;
    padding: 4px 6px;
    margin: 0 14px 0 0;
    flex: 0 0 auto;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    width: calc(100% - 250px);
  }
`
